// Capital city coordinates for every country in /data/countries.js (moved out of MiniGlobe so 2D maps never load three.js).
export const COUNTRY_COORDS = {
  // Europe
  fr: [48.85, 2.35], gb: [51.5, -0.13], it: [41.9, 12.5], es: [40.42, -3.7],
  de: [52.52, 13.4], gr: [37.98, 23.72], nl: [52.37, 4.9],
  se: [59.33, 18.07], no: [59.91, 10.75], pt: [38.72, -9.14], pl: [52.23, 21.01],
  ru: [55.76, 37.62], ch: [46.95, 7.45],
  al: [41.33, 19.82], ad: [42.51, 1.52], at: [48.21, 16.37], by: [53.90, 27.57],
  be: [50.85, 4.35], ba: [43.86, 18.41], bg: [42.70, 23.32], hr: [45.81, 15.98],
  cy: [35.19, 33.36], cz: [50.09, 14.42], dk: [55.68, 12.57], ee: [59.44, 24.75],
  fi: [60.17, 24.94], hu: [47.50, 19.04], is: [64.15, -21.94], ie: [53.35, -6.26],
  xk: [42.67, 21.17], lv: [56.95, 24.10], li: [47.14, 9.52], lt: [54.69, 25.28],
  lu: [49.61, 6.13], mt: [35.90, 14.51], md: [47.01, 28.86], mc: [43.74, 7.42],
  me: [42.44, 19.26], mk: [41.99, 21.43], ro: [44.44, 26.10], sm: [43.94, 12.45],
  rs: [44.79, 20.45], sk: [48.15, 17.11], si: [46.05, 14.51], ua: [50.45, 30.52],
  va: [41.90, 12.45],
  // Asia — expanded coverage
  in: [28.61, 77.21], cn: [39.9, 116.4], jp: [35.68, 139.69], kr: [37.57, 126.98],
  th: [13.75, 100.5], ae: [24.47, 54.37],
  sa: [24.71, 46.68], id: [-6.21, 106.85], vn: [21.03, 105.85], ph: [14.6, 120.98],
  il: [31.77, 35.21], sg: [1.35, 103.82], tr: [39.93, 32.86], ir: [35.69, 51.39],
  af: [34.53, 69.17], am: [40.18, 44.51], az: [40.41, 49.87], bh: [26.23, 50.58],
  bd: [23.81, 90.41], bt: [27.47, 89.64], bn: [4.90, 114.94], kh: [11.55, 104.92],
  tl: [-8.56, 125.56], ge: [41.72, 44.79], iq: [33.32, 44.36], jo: [31.95, 35.93],
  kz: [51.13, 71.43], kw: [29.38, 47.99], kg: [42.87, 74.60], la: [17.97, 102.60],
  lb: [33.89, 35.50], my: [3.14, 101.69], mv: [4.17, 73.51], mn: [47.89, 106.91],
  mm: [19.75, 96.10], np: [27.72, 85.32], kp: [39.02, 125.75], om: [23.59, 58.41],
  pk: [33.68, 73.05], ps: [31.90, 35.20], qa: [25.29, 51.53], lk: [6.93, 79.86],
  sy: [33.51, 36.30], tw: [25.03, 121.57], tj: [38.56, 68.79], tm: [37.95, 58.38],
  uz: [41.30, 69.24], ye: [15.35, 44.21],
  // Africa
  eg: [30.04, 31.24], za: [-25.75, 28.19], ke: [-1.29, 36.82], ma: [33.97, -6.84], ng: [9.07, 7.49],
  et: [9.03, 38.74], gh: [5.6, -0.19], tz: [-6.16, 35.75], sn: [14.69, -17.45],
  dz: [36.75, 3.06], ao: [-8.84, 13.29], bj: [6.50, 2.60], bw: [-24.63, 25.92],
  bf: [12.37, -1.53], bi: [-3.43, 29.92], cm: [3.85, 11.50], cv: [14.93, -23.51],
  cf: [4.36, 18.56], td: [12.13, 15.05], km: [-11.70, 43.24], cd: [-4.44, 15.27],
  cg: [-4.26, 15.28], dj: [11.59, 43.15], gq: [3.75, 8.78], er: [15.32, 38.93],
  sz: [-26.30, 31.14], ga: [0.42, 9.45], gm: [13.45, -16.58], gn: [9.54, -13.68],
  gw: [11.86, -15.60], ci: [6.83, -5.28], ls: [-29.31, 27.48], lr: [6.30, -10.80],
  ly: [32.89, 13.19], mg: [-18.87, 47.51], mw: [-13.98, 33.79], ml: [12.65, -8.00],
  mr: [18.08, -15.98], mu: [-20.16, 57.50], mz: [-25.97, 32.58], na: [-22.56, 17.08],
  ne: [13.52, 2.11], rw: [-1.97, 30.10], st: [0.34, 6.73], sc: [-4.62, 55.45],
  sl: [8.48, -13.23], so: [2.05, 45.32], ss: [4.85, 31.58], sd: [15.50, 32.56],
  tg: [6.14, 1.21], tn: [36.81, 10.18], ug: [0.32, 32.58], zm: [-15.42, 28.28],
  zw: [-17.83, 31.05],
  // North America
  us: [38.9, -77.04], ca: [45.42, -75.7], mx: [19.43, -99.13], cu: [23.13, -82.38], jm: [17.97, -76.79],
  cr: [9.93, -84.08], pa: [8.98, -79.52],
  ag: [17.12, -61.85], bs: [25.05, -77.35], bb: [13.10, -59.61], bz: [17.25, -88.77],
  dm: [15.30, -61.39], do: [18.47, -69.90], sv: [13.69, -89.19], gd: [12.06, -61.75],
  gt: [14.63, -90.51], ht: [18.54, -72.34], hn: [14.10, -87.22], ni: [12.15, -86.27],
  kn: [17.30, -62.72], lc: [14.01, -60.99], vc: [13.16, -61.22], tt: [10.65, -61.51],
  // South America
  br: [-15.79, -47.88], ar: [-34.61, -58.38], pe: [-12.05, -77.04], co: [4.71, -74.07], cl: [-33.45, -70.66],
  ve: [10.48, -66.9],
  bo: [-19.03, -65.26], ec: [-0.18, -78.47], gy: [6.80, -58.16], py: [-25.29, -57.65],
  sr: [5.85, -55.20], uy: [-34.90, -56.19],
  // Oceania
  au: [-35.28, 149.13], nz: [-41.29, 174.77], fj: [-18.14, 178.44], pg: [-9.45, 147.18],
  ki: [1.33, 172.98], mh: [7.09, 171.38], fm: [6.92, 158.16], nr: [-0.55, 166.92],
  pw: [7.34, 134.48], ws: [-13.83, -171.77], sb: [-9.43, 159.96], to: [-21.14, -175.20],
  tv: [-8.52, 179.20], vu: [-17.73, 168.32],
  // Antarctica
  aq: [-82.86, 135],
};
